import { Shadow, VStack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';
import { useRecoilValue } from 'recoil';

import { reportTypeOptionState } from '../../../../../../store/customerDetail/reports/atom';

import { Download as AnnualIncomeDownload } from './AnnualIncome/Download';
import { List as BrokerageList } from './Brokerage/List';
import { Download as ComplementaryDownload } from './Complementary/Download';
import { Header } from './Header';
import { List as MarginList } from './Margin/List';

interface ReportsProps {}
interface ShadowWrapperProps {
  children: React.ReactElement;
}

const ShadowWrapper: React.FC<ShadowWrapperProps> = ({ children }) => (
  <Shadow level={3} borderRadius={BoxRadius.sm} mt={Spacing['inline.xxs']}>
    {children}
  </Shadow>
);

export const Reports: React.FC<ReportsProps> = () => {
  const Wrapper = useBreakpointValue({
    base: React.Fragment,
    sm: ShadowWrapper,
  });

  const reportTypeOption = useRecoilValue(reportTypeOptionState);

  return (
    <Wrapper>
      <VStack
        bg={{ base: 'transparent', sm: 'white' }}
        borderRadius={{ base: 'none', sm: BoxRadius.sm }}
        zIndex={5}
        space={{ base: Spacing['stack.xxxs'], lg: 0 }}>
        <Header />
      </VStack>
      {reportTypeOption === 'brokerage-note' && <BrokerageList />}
      {reportTypeOption === 'margin' && <MarginList />}
      {reportTypeOption === 'annual-income-report' && <AnnualIncomeDownload />}
      {reportTypeOption === 'complementary' && <ComplementaryDownload />}
    </Wrapper>
  );
};
